import React from 'react'
import { useSiteMetadata } from '../hooks/use-site-metadata'

const Seo = ({
  title,
  description,
  ogTitle,
  ogDescription,
  ogType,
  ogSiteName,
  ogImage,
  twitterCard,
  twitterCreator,
  twitterTitle,
  twitterDescription,
  twitterImage,
  children
}) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    author: defaultAuthor,
    siteUrl
  } = useSiteMetadata()
  const ogUrl = typeof window !== 'undefined' ? window.location.pathname : null
  const ogSiteNameDefault = `Retail Self Checkout Solution, Scan N Thru`
  const ogTypeDefault = `article`
  const twitterCardDefault = `summary_large_image`

  const seoMeta = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    ogTitle: ogTitle || title,
    ogDescription: ogDescription || description,
    ogType: ogType || ogTypeDefault,
    ogUrl: `${siteUrl}${ogUrl}`,
    ogSiteName: ogSiteName || ogSiteNameDefault,
    ogImage: `${siteUrl}${ogImage}`,
    twitterCard: twitterCard || twitterCardDefault,
    twitterCreator: twitterCreator || defaultAuthor,
    twitterTitle: twitterTitle || title,
    twitterDescription: twitterDescription || description,
    twitterImage: `${siteUrl}${twitterImage}`
  }
  const schemaOrgJSONLD = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Scan&Thru.com',
    description: `${defaultDescription}`,
    alternateName: 'Scan&Thru.com',
    url: `${siteUrl}`,
    logo: `${siteUrl}/logo.svg`,
    sameAs: [
      'https://www.facebook.com/digipay.guru',
      'https://twitter.com/DigipayGuru',
      'https://www.linkedin.com/company/scan-n-thru/',
      'https://www.instagram.com/digipay.guru/',
      'https://www.youtube.com/channel/UC0idP2LkVrJ7lryMuWIR5DA'
    ]
  }
  return (
    <>
      <title>{seoMeta.title}</title>
      <meta name='description' content={seoMeta.description} />
      <meta name='og:title' content={seoMeta.ogTitle} />
      <meta name='og:description' content={seoMeta.ogDescription} />
      <meta name='og:type' content={seoMeta.ogType} />
      <meta name='og:url' content={seoMeta.ogUrl} />
      <meta name='og:site_name' content={seoMeta.ogSiteName} />
      <meta name='og:image' content={seoMeta.ogImage} />
      <meta name='twitter:card' content={seoMeta.twitterCard} />
      <meta name='twitter:creator' content={seoMeta.twitterCreator} />
      <meta name='twitter:title' content={seoMeta.twitterTitle} />
      <meta name='twitter:description' content={seoMeta.twitterDescription} />
      <meta name='twitter:image' content={seoMeta.twitterImage} />
      {/* <meta name="robots" content="noindex, nofollow" /> */}
      <meta name='google-site-verification' content='JG9YNvUrijHG1dmpz_yB2mRxa2AksJ-q-ogNmnkE-Yc' />
      {children}
      <script type='application/ld+json'>
        {JSON.stringify(schemaOrgJSONLD)}
      </script>
    </>
  )
}

export default Seo
